import { ReactElement, ReactNode, forwardRef } from 'react'
import { Platform } from 'react-native'

import FormControl, { FormControlProps } from 'app/components/base/FormControl'
import QuantityInput, {
  QuantityInputProps
} from 'app/components/base/QuantityInput/QuantityInput'
import useFormField, { UseFormFieldProps } from 'app/hooks/useFormField'
import { combineControllerProps } from 'app/utils/helpers/form.helpers'

export interface QuantityFieldCustomProps extends UseFormFieldProps {
  helperText?: ReactElement | ReactNode | null
  formControlProps?: FormControlProps
  disabled?: boolean
  maxValue?: number
}

export type QuantityFieldNumberProps = QuantityFieldCustomProps &
  QuantityInputProps

const QuantityFieldNumber = (
  {
    helperText,
    disabled,
    maxValue,
    formControlProps,
    ...props
  }: QuantityFieldNumberProps,
  ref: any
) => {
  const { controllerProps, ...rest } = combineControllerProps(props)
  const { field, error, onChange, value } = useFormField(controllerProps)

  return (
    <FormControl
      errorMessage={error}
      helperText={helperText}
      fullWidth={false}
      {...formControlProps}
    >
      <QuantityInput
        {...field}
        ref={ref}
        error={!!error}
        value={value}
        disabled={disabled}
        maxValue={maxValue}
        {...Platform.select({
          web: { onChange },
          native: { onChangeText: onChange }
        })}
        inputProps={{ 'aria-label': 'quantity' }}
        {...rest}
      />
    </FormControl>
  )
}

export default forwardRef(QuantityFieldNumber)
